import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import { WomanOutlined, ManOutlined, TranslationOutlined } from "@ant-design/icons";
import { AxiosResponse } from "axios";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import useFetch from "../../../../../hooks/useFetch";
import { FetchApiInterface } from "../../../../../interfaces/FetchApi.interface";
import { ResponseInterface } from "../../../../../interfaces/Response.interface";
import useMessageUser from "../../../../../hooks/useMessageUser";
import { getScopes } from "../../helperComms";
import useExport from "../../../../../hooks/comms/useExport";
import { USER_INFO } from "../../../../../config/config";
import { SESSION_KEY } from '../../pages/Scuapp/TraductorDetalle';

const { TextArea } = Input;

const VALID_STATUSES = [ "PENDING", "OVERDUE_PENDING", "RECEIVED_LATE", "RECEIVED_ON_TIME", "AI_PROCESSING", "TRANSLATING", "TRANSLATED", "OBSERVED", "OBSERVATION_SENT", "TRANSLATION_COMPLETE", "FAILED", "PENDING_RETURN", "RECOVERED" ];

const directionMap: Record<string, string> = {
  'SC-SP': 'SC_TO_SP',
  'SP-SC': 'SP_TO_SC',
};

function DetailSc6({ openDetailSc, setOpenDetailSc, data: dataSc, getTabla }: { openDetailSc: boolean, setOpenDetailSc: Function, data: any, getTabla: Function }) {
  const [form] = Form.useForm();
  const scopes = getScopes();
  const { fetchApi } = useFetch();
  const { showMessage } = useMessageUser();
  const { t } = useTranslation();
  const [conAbsent, setConAbsent] = useState<boolean>(false);
  const [processQualities, setProcessQualities] = useState<any[]>([]);
  const [inappropriateContent, setInappropriateContent] = useState<any[]>([]);
  const [downloadingPdf, setDownloadingPdf] = useState<boolean>(false);
  const [rejectModalVisible, setRejectModalVisible] = useState<boolean>(false);
  const [reasonOfReturn, setReasonOfReturn] = useState<string>('');
  const [rejectingCommitment, setRejectingCommitment] = useState<boolean>(false);
  const [openTranslateModal, setOpenTranslateModal] = useState<boolean>(false);
  const [translateForm] = Form.useForm();
  const [translatorLanguages, setTranslatorLanguages] = useState<any[]>([]);
  const [submittingSync, setSubmittingSync] = useState<boolean>(false);
  const { exportZIP } = useExport();

  const isTranslatable = VALID_STATUSES.includes(dataSc?.status);
  const isPdf = dataSc?.assComType === 'PDF';

  useEffect(() => {
    if (openDetailSc) {
      inappropriate();
      Process();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDetailSc]);

  useEffect(() => {
    form.resetFields();
    if (dataSc) {
      setConAbsent(dataSc?.conAbsent);
      form.setFieldsValue({
        conReadDate: dataSc?.conReadDate && moment(dataSc?.conReadDate),
        conAbsent: dataSc?.conAbsent || false,
        newDate: dataSc?.newDate && moment(dataSc?.newDate),
        conIncludePhoto: dataSc?.conIncludePhoto || false,
        conAskQuestions: dataSc?.conAskQuestions || false,
        conPersonalLife: dataSc?.conPersonalLife || false,
        conExplainDraw: dataSc?.conExplainDraw || false,
        conScFeelings: dataSc?.conScFeelings || false,
        conPhoto: dataSc?.conPhoto || false,
        conLetter: dataSc?.conLetter || false,
        conFingerprint: dataSc?.conFingerprint || false,
        conScLessFiveYears: dataSc?.conScLessFiveYears || false,
        inappropriateContent: dataSc?.icoId || 1,
        processQualities: dataSc?.pquId || 1,
      });
      if (!dataSc?.conReadDate) {
        form.setFieldValue('conReadDate', moment());
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSc]);

  const inappropriate = () => {
    const dataSend: FetchApiInterface = {
      url: `/comms/inappropriate-content`,
      method: 'GET'
    }
    fetchApi(dataSend).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') {
          setInappropriateContent(data?.data || []);
        } else {
          showMessage(data?.message, 'info');
        }
      }
    ).catch((reason: any) => {
      showMessage(reason?.message, 'error');
    });
  }
  const Process = () => {
    const dataSend: FetchApiInterface = {
      url: `/comms/process-qualities`,
      method: 'GET'
    }
    fetchApi(dataSend).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') {
          setProcessQualities(data?.data || []);
        } else {
          showMessage(data?.message, 'info');
        }
      }
    ).catch((reason: any) => {
      showMessage(reason?.message, 'error');
    });
  }

  const downloadImages = async () => {
    if (!dataSc?.assId) {
      showMessage(t('commitmentIdNotFound'), 'error');
      return;
    }

    setDownloadingPdf(true);
    try {
      const payload = { ids: [dataSc.assId] };
      await exportZIP('/comms/control/download_commitments', payload, 'comunicacion');
    } catch (error) {
      console.error('Error al descargar el ZIP', error);
      showMessage(t('errorDuringPdfDownload'), 'error');
    } finally {
      setDownloadingPdf(false);
    }
  };

  const handleCheckSaveAbsent = () => {

    if (conAbsent) {
      setRejectModalVisible(true);
      setReasonOfReturn('');
    } else {
      // guardamos directamente el formulario
      onFinish(form.getFieldsValue());
    }
  };

  const confirmRejectCommitment = async () => {
    if (!dataSc?.assId) {
      showMessage(t('commitmentIdNotFound'), 'error');
      return;
    }

    if (!reasonOfReturn.trim()) {
      showMessage(t('reasonOfReturnRequired'), 'error');
      return;
    }

    setRejectingCommitment(true);

    onFinish(form.getFieldsValue(), reasonOfReturn);
  };

  const onFinish = (values: any, reasonOfReturn: string = '') => {
    setRejectModalVisible(false);
    setRejectingCommitment(false);
    // Convertir las fechas a formato "YYYY-MM-DD"
    let formattedValues = {
      ...values,
      scNumber: dataSc?.ascScNumber,
      assId: dataSc?.assId,
      conReadDate: values.conReadDate ? moment(values.conReadDate).format('YYYY-MM-DD') : undefined,
      // conAbsenceDate: values.conAbsenceDate ? moment(values.conAbsenceDate).format('YYYY-MM-DD') : undefined,
    };

    if (reasonOfReturn) {
      formattedValues.meetingReason = reasonOfReturn;
    }

    delete formattedValues.newDate;
    /*if (values?.conAbsent === false) {
      delete formattedValues.conAbsenceDate;
    }*/
    // validar que venga en true al menos una de las opciones conPhoto, conLetter, conFingerprint, conScLessFiveYears
    if (!isPdf && !formattedValues.conPhoto && !formattedValues.conLetter && !formattedValues.conFingerprint && !formattedValues.conScLessFiveYears) {
      notification.error({
        message: 'Error',
        description: (
          <div>
            <p>{t('titleOptionRequired')}</p>
            <ul>
              <li>{t('requiredOptionParticipation')} {t('scParticipation')}</li>
            </ul>
          </div>
        ),
      });
      return;
    }

    if (!isPdf && !formattedValues.conIncludePhoto && !formattedValues.conAskQuestions && !formattedValues.conPersonalLife && !formattedValues.conExplainDraw && !formattedValues.conScFeelings) {
      notification.error({
        message: 'Error',
        description: (
          <div>
            <p>{t('titleOptionRequired')}</p>
            <ul>
              <li>{t('requiredOptionParticipation')} {t('valuableDialogue')}</li>
            </ul>
          </div>
        ),
      });
      return;
    }

    const dataSend: FetchApiInterface = {
      url: `/comms/control`,
      data: {
        conMakeSpQuestions: false,
        conIncludePhoto: false,
        conPersonalLife: false,
        conAskQuestions: false,
        conDraw: false,
        conScFeelings: false,
        conExplainDraw: false,
        conActivities: false,
        ...(isPdf && { conAbsent: false }),
        ...formattedValues,
      },
    }
    fetchApi(dataSend).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') {
          showMessage(data?.message, 'success');
          setOpenDetailSc(false);
          getTabla();
        } else {
          showMessage(data?.message, 'info');
        }
      }
    ).catch((reason: any) => {
      const dataReason = reason?.data || {};
      // Recorremos el objeto de errores y presentamos en una lista de notification
      notification.error({
        message: 'Error',
        description: (
          <div>
            <p>Por favor revisar los siguientes errores:</p>
            <ul>
              {
                Object.keys(dataReason).map((key: any) => (
                  <li key={key}>{key}: {dataReason[key]}</li>
                ))
              }
            </ul>
          </div>
        ),
      });
      showMessage(reason?.message, 'error');
    });
  }

  const calcYear = () => {
    if (!dataSc?.ascScBornDate) return;
    // calculamos la edad en años del SC ' ascScBornDate
    const bornDate = new Date(dataSc?.ascScBornDate);
    const today = new Date();
    const diff = today.getTime() - bornDate.getTime();
    const age = new Date(diff);
    return Math.abs(age.getUTCFullYear() - 1970);
  }

  const getTranslatorLanguages = () => {
    const dataSend: FetchApiInterface = { url: `/language/translator_language`, method: 'GET' };
    fetchApi(dataSend).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') setTranslatorLanguages(data?.data || []);
      }
    ).catch(() => {});
  };

  const openTraductorDetalle = (item: any) => {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify([item]));
    window.open('/scuapp/traductor-detalle?origin=comp_6', '_blank');
  };

  const handleOpenTranslateModal = () => {
    const isNew = !dataSc?.assignedTranslatorId && !dataSc?.translationId;
    if (!isNew) {
      openTraductorDetalle({
        ...dataSc,
        id: dataSc?.translationId ?? dataSc?.requestId,
        assignedId: dataSc?.assId,
        scNumber: dataSc?.ascScNumber,
        spNumber: dataSc?.assSpNumber,
        scName: dataSc?.ascScName,
        spName: dataSc?.assSpName,
        comType: dataSc?.assComType,
      });
      return;
    }
    translateForm.resetFields();
    translateForm.setFieldsValue({
      direction: dataSc?.assComType === 'PDF' ? 'SP-SC' : 'SC-SP',
    });
    getTranslatorLanguages();
    setOpenTranslateModal(true);
  };

  const handleTranslateSubmit = () => {
    translateForm.validateFields().then((values) => {
      const userInfo = JSON.parse(localStorage.getItem(USER_INFO) || '{}');
      const userId = String(userInfo?.useId ?? userInfo?.user?.useId ?? '');
      const targetLang = translatorLanguages.find((l: any) => l.tlaName === values.targetLanguage);

      const payload = {
        requestedByUserId: userId,
        assignedTranslatorId: userId,
        sourceLanguageId: 1,
        targetLanguageId: targetLang?.tlaId,
        translationDirection: directionMap[values.direction] ?? values.direction,
        dueDate: moment().format('YYYY-MM-DDTHH:mm:ss[Z]'),
        translatorNotes: 'S/N',
        createdBy: '',
        communications: [{
          assignedId: dataSc?.assId,
          referenceNumber: String(dataSc?.assRef ?? ''),
          fileNames: [dataSc?.conImage, dataSc?.conImageOptional].filter(Boolean),
        }],
      };

      const dataSend: FetchApiInterface = { url: '/translations/requests/sync', method: 'POST', data: payload };
      setSubmittingSync(true);
      fetchApi(dataSend).then(({ data }: AxiosResponse<any>) => {
        const syncResponse = data?.requestId ? data : data?.data;
        const item = {
          ...dataSc,
          id: syncResponse?.requestId,
          translationDirection: directionMap[values.direction],
          assignedId: dataSc?.assId,
          scNumber: dataSc?.ascScNumber,
          spNumber: dataSc?.assSpNumber,
          scName: dataSc?.ascScName,
          spName: dataSc?.assSpName,
          comType: dataSc?.assComType,
          sourceLanguage: syncResponse?.documents?.[0]?.sourceLanguageName,
          targetLanguage: syncResponse?.documents?.[0]?.targetLanguageName,
        };
        setOpenTranslateModal(false);
        openTraductorDetalle(item);
      }).catch((err: any) => {
        notification.error({ message: 'Error', description: err?.detail || err?.message || 'Error al sincronizar la traducción.' });
      }).finally(() => setSubmittingSync(false));
    });
  };

  // Solo permitir la fecha actual
  const disableNonTodayDates = (current: any) => {
    const today = moment().startOf('day');
    return current && !current.isSame(today, 'day');
  };

  return (
    <>
      <Modal
        title={dataSc?.lastModifiedBy ?? ' '}
        open={openDetailSc}
        onOk={() => form.submit()}
        onCancel={() => setOpenDetailSc(false)}
        width={1000}
        okText={t('save')}
        cancelText={t('cancel')}
        footer={[
          <Row justify='end'>
            <Col>
            {isTranslatable && (
                <Button
                  type="default"
                  shape='round'
                  icon={<TranslationOutlined />}
                  onClick={handleOpenTranslateModal}
                  style={{ marginLeft: 8 }}
                >
                  Traducir carta
                </Button>
              )}
              {/* presentamos este boton solo cuando el status tiene la palabra Recibido */}
              {
                dataSc?.status?.includes('Recibido') && (
                  <Button
                    type="default"
                    shape='round'
                    loading={downloadingPdf}
                    onClick={downloadImages}
                    style={{ marginLeft: 8 }}
                  >
                    {t('downloadImages')}
                  </Button>
                )}
              <Button type="primary" ghost shape='round' onClick={() => setOpenDetailSc(false)}>{t('cancel')}</Button>
              {
                (scopes.includes('COMP_6_SAVE')) && (
                  <Button type="primary" shape='round' onClick={() => form.submit()}>{t('save')}</Button>
                )
              }
              
            </Col>
          </Row>
        ]}
      >
        <Form form={form} disabled={!scopes.includes('COMP_6_SAVE')} layout='vertical' onFinish={handleCheckSaveAbsent}>
          <Row gutter={[20, 20]}>
            <Col span={24} md={8}>
              <Card style={{ borderRadius: 10 }}>
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                  {
                    (dataSc?.ascScGenre === 'Female')
                      ? <WomanOutlined style={{ fontSize: 80 }} />
                      : <ManOutlined style={{ fontSize: 80 }} />
                  }
                  <h2>{dataSc?.ascScName}</h2>
                  <h3>{calcYear()} {t('yearsOld')}</h3>
                  <Divider />
                </div>
                <p><strong>{t('scNumber')}:</strong> {dataSc?.ascScNumber}</p>
                <p><strong>{t('no')}:</strong> {dataSc?.assNo}</p>
                <p><strong>{t('sp')}:</strong> {dataSc?.assSpNumber} </p>
                <p><strong>{t('spName')}:</strong> {dataSc?.assSpName} </p>
                <p><strong>{t('type')}:</strong> {dataSc?.assComType}</p>
                <p><strong>{t('obs')}:</strong> {dataSc?.assObs} </p>
                <p><strong>{t('pu')}:</strong> {dataSc?.ascPuCode}</p>
                <p><strong>{t('community')}:</strong> {dataSc?.ascLevel}</p>
                <p><strong>{t('fdc')}:</strong> {dataSc?.ascCwCode} - {dataSc?.ascCw}</p>
                {dataSc?.meetingReason && <p><strong>{t('meetingReason')}:</strong> {dataSc?.meetingReason}</p>}
                <Divider />
                <p><strong>{t('modificationDate')}:</strong> {dataSc?.conReadDate}</p>
              </Card>
            </Col>
            <Col span={24} md={16}>
              <Row gutter={[20, 20]}>
                <Col span={24}>
                  <Card style={{ borderRadius: 10 }}>
                    <Row gutter={[10, 10]}>
                      <Col span={24}>
                        <Row gutter={[10, 10]}>
                          <Col span={24} md={12}>
                            <Form.Item
                              name="conReadDate"
                              label={t('readDate')}
                              rules={[{ required: !isPdf, message: t('selectDate') }]}
                              initialValue={moment()}
                            >
                              <DatePicker className="w-100" disabledDate={disableNonTodayDates} format="DD-MM-YYYY" />
                            </Form.Item>
                            {!isPdf && (
                              <Form.Item
                                name="conAbsent"
                                valuePropName='checked'
                                label={t('absentFromCommunity')}
                              >
                                <Checkbox onChange={(e: CheckboxChangeEvent) => setConAbsent(e.target.checked)}>{t('absent')}</Checkbox>
                              </Form.Item>
                            )}
                          </Col>
                          <Col span={24} md={12}>
                            <Form.Item
                              name="newDate"
                              label={t('childDataDueDate')}
                              rules={[{ required: true, message: t('selectDate') }]}
                            >
                              <DatePicker className="w-100" disabled format="DD-MM-YYYY" />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Divider />
                      </Col>
                      <Col span={24} md={12}>
                        <p><strong><span className='text-danger'>* </span> {t('valuableDialogue')}:</strong></p>
                        <Form.Item name="conIncludePhoto" valuePropName='checked'>
                          <Checkbox>{t('includePhoto')}</Checkbox>
                        </Form.Item>
                        <Form.Item name="conAskQuestions" valuePropName='checked'>
                          <Checkbox>{t('answersQuestions')}</Checkbox>
                        </Form.Item>
                        <Form.Item name="conPersonalLife" valuePropName='checked'>
                          <Checkbox>{t('talksAboutPersonalLife')}</Checkbox>
                        </Form.Item>
                        <Form.Item name="conExplainDraw" valuePropName='checked'>
                          <Checkbox>{t('explainsDrawing')}</Checkbox>
                        </Form.Item>
                        <Form.Item name="conScFeelings" valuePropName='checked'>
                          <Checkbox>{t('expressesFeelings')}</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={24} md={12}>
                        <Form.Item rules={[{ required: !isPdf, message: t('codeRequired') }]} label={t('inappropriateContent')} name="inappropriateContent">
                          <Select>
                            {
                              inappropriateContent.map((item: any, key: number) => (
                                <Select.Option key={key} value={item?.icoId}>{t(item?.icoText)}</Select.Option>
                              ))
                            }
                          </Select>
                        </Form.Item>
                        <Divider />
                        <p><strong><span className='text-danger'>* </span> {t('scParticipation')}:</strong></p>
                        <Form.Item name="conPhoto" valuePropName='checked'>
                          <Checkbox>{t('photo')}</Checkbox>
                        </Form.Item>
                        <Form.Item name="conLetter" valuePropName='checked'>
                          <Checkbox>{t('letter')}</Checkbox>
                        </Form.Item>
                        <Form.Item name="conFingerprint" valuePropName='checked'>
                          <Checkbox>{t('fingerprint')}</Checkbox>
                        </Form.Item>
                        <Form.Item name="conScLessFiveYears" valuePropName='checked'>
                          <Checkbox>{t('scUnderFiveYears')}</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item rules={[{ required: !isPdf, message: t('codeRequired') }]} label={t('processQuality')} name="processQualities">
                          <Select>
                            {
                              processQualities.map((item: any, key: number) => (
                                <Select.Option key={key} value={item?.pquId}>{t(item?.pquText)}</Select.Option>
                              ))
                            }
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* Modal para iniciar traducción */}
      <Modal
        centered
        title={t('translateLetterTitle')}
        open={openTranslateModal}
        onCancel={() => setOpenTranslateModal(false)}
        width={440}
        footer={
          <Space>
            <Button shape='round' onClick={() => setOpenTranslateModal(false)}>{t('cancel')}</Button>
            <Button shape='round' type='primary' icon={<TranslationOutlined />} loading={submittingSync} onClick={handleTranslateSubmit}>
              {t('continue')}
            </Button>
          </Space>
        }
      >
        <Form form={translateForm} layout='vertical' style={{ marginTop: 16 }}>
          <Form.Item
            name='direction'
            label={t('translationDirection')}
            rules={[{ required: true, message: t('selectDirection') }]}
          >
            <Radio.Group>
              <Radio value='SC-SP'>SC → SP</Radio>
              <Radio value='SP-SC'>SP → SC</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name='targetLanguage'
            label={t('finalLanguage')}
            rules={[{ required: true, message: t('selectFinalLanguage') }]}
          >
            <Select placeholder={t('selectLanguagePlaceholder')}>
              {translatorLanguages.map((l: any) => (
                <Select.Option key={l.tlaId} value={l.tlaName}>{l.tlaName}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal para rechazar compromiso */}
      <Modal
        title={t('rejectCommitmentTitle')}
        open={rejectModalVisible}
        onOk={confirmRejectCommitment}
        onCancel={() => {
          setRejectModalVisible(false);
          setReasonOfReturn('');
        }}
        okText={t('reject')}
        cancelText={t('cancel')}
        confirmLoading={rejectingCommitment}
        okButtonProps={{ danger: true }}
      >
        <div style={{ marginBottom: 16 }}>
          <p>{t('rejectCommitmentMessage')}</p>
        </div>
        <TextArea
          rows={4}
          value={reasonOfReturn}
          onChange={(e) => setReasonOfReturn(e.target.value)}
          placeholder={t('reasonOfReturnPlaceholder')}
          maxLength={500}
          showCount
        />
      </Modal>
    </>
  );
}

export default DetailSc6;
